import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BubbleChart from '@weknow/react-bubble-chart-d3';
import { getDarkerColor, rgbToHex } from 'utils/colors';
import Deliverables from 'components/Steps/Deliverables';
import './styles.css';

class BubbleChartComponent extends Component {
  state = {
    hide: false,
    filteredOptions: [],
  }

  handleClick = (label) => {
    const { options } = this.props;
    const first = options.find(elem => elem.label === label);
    const filteredOptions = options.filter(elem => elem.label !== label);
    filteredOptions.unshift(first);
    this.setState({ hide: true, filteredOptions });
  }

  render() {
    const { options, color } = this.props;
    const { hide, filteredOptions } = this.state;
    const width = Math.min(window.innerWidth, window.innerHeight / 1.5, 700);

    const fontSize = width > 500 ? 14 : 9;

    const bubbleColor = color.contrastColor || rgbToHex(getDarkerColor(color));
    // const fontSize = window.innerWidth > 768 ? 16 : 12;
    const data = options.filter(elem => elem.value !== 0).map((elem2) => {
      return {
        ...elem2,
        color: bubbleColor,
      };
    });
    if (!hide) {
      return (
        <BubbleChart
          graph={{
            zoom: 0.9, // 1.1 means 110% of zoom.
            offsetX: 0, // -0.05 means that the offset is -5% of the graph width.
            offsetY: 0,
          }}
          width={width}
          height={width}
          padding={0}
          overflow
          showLegend={false} // optional value, pass false to disable the legend.
          legendPercentage={0} // number that represent the % of with that legend going to use.
          valueFont={{
            family: 'Raleway',
            size: 0,
            color: bubbleColor,
          }}
          labelFont={{
            family: 'Raleway',
            size: fontSize,
            color: color.color || '#fff',
            wordWrap: 'break-word',
          }}
          bubbleClickFun={this.handleClick}
          legendClickFun={this.legendClick}
          data={data}
        />
      );
    }
    return <Deliverables elements={filteredOptions} showClose showLike={false} onClose={() => this.setState({ hide: false })} />;
  }
}

BubbleChartComponent.propTypes = {
  options: PropTypes.array.isRequired,
  color: PropTypes.string.isRequired,
};

export default BubbleChartComponent;



// WEBPACK FOOTER //
// ./src/components/Steps/BubbleChart/components/BubbleChart.jsx